import React from 'react';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from '../../components/alert-dialog';
import { useTranslation } from 'react-i18next';

interface LogoutDialogProps {
    showLogoutDialog: boolean;
    setShowLogoutDialog: (show: boolean) => void;
    onLogout: () => void;
}

const LogoutDialog: React.FC<LogoutDialogProps> = ({
    showLogoutDialog,
    setShowLogoutDialog,
    onLogout
}) => {
    const { t } = useTranslation();
    return (
        <AlertDialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('auth.logout_confirm')}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('auth.logout_confirm_description')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
                    <AlertDialogAction onClick={onLogout}>{t('common.logout')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default LogoutDialog; 